"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchBoxWrapper = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
const SearchBoxWrapper = exports.SearchBoxWrapper = _styledComponents.default.div.withConfig({
  displayName: "Searchstyle__SearchBoxWrapper",
  componentId: "sc-1d74mry-0"
})(["margin:0 -4px;"]);